import { Heading, HStack, Text, VStack } from '@chakra-ui/react';
import React, { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  title: string;
  subtitle?: string;
  sup?: string;
  bg?: string;
}

export const PageTitle: FC<Props> = ({
  title,
  subtitle,
  sup,
  children,
  bg
}) => {
  return (
    <HStack
      sx={{
        justifyContent: 'space-between',
        alignItems: ['flex-start', 'flex-start', 'center'],
        flexDirection: ['column', 'column', 'row'],
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        padding: ['12px', '12px 24px'],
        overflow: 'hidden',
        borderRadius: '16px'
      }}
      gap={3}
    >
      <VStack
        alignItems="flex-start"
        sx={{
          marginBottom: ['24px', 0],
          position: 'relative'
        }}
      >
        <Heading
          as="h3"
          fontSize="32px"
          fontWeight={500}
          lineHeight="32px"
          position="relative"
        >
          {title}
        </Heading>
        {sup && (
          <Text
            color="neutral.100"
            fontSize={14}
            px={3}
            py={1}
            backgroundColor="neutral.700"
            borderRadius="8px"
            position="absolute"
            left="100%"
            top="0px"
            whiteSpace="nowrap"
          >
            {sup}
          </Text>
        )}
        {subtitle && (
          <Text
            fontSize="16px"
            fontWeight="400"
            lineHeight="20px"
            color="whiteOpacity.50"
          >
            {subtitle}
          </Text>
        )}
      </VStack>
      {children}
    </HStack>
  );
};
